import useGame from "./stores/useGame"

import './style.css'

export default function UI()
{
    

    const phase =  useGame((state) => state.phase)
    const reset = useGame((state) => state.reset)
    const zoom = useGame((state) => state.zoom)
    

        return <>

        <div className='banner-top'>
            <img src="./DSL_Logo_stackedonWHT_Transp_Web_120.png" className="image-wrap" onClick={()=>{window.open('https://www.darkstarlabs.io/')}}></img>
        </div> 
  
        <div className='interface'>

        { phase === 'zoomed' && 
            <div className="action-card" onClick={() => {reset(), zoom()}}>
                <div className='navButton'> RETURN </div> 
            </div> 
        }


        </div> 

        <div className='heroTitle'>
        <div className='redHead'>Lorem ipsum dolor sit amet</div>
            <div className='heading'>Sed ut perspiciatis</div>
            <div className='subHeading'>At vero eos et accusamus et iusto odio dignissimos</div>
        </div> 

   
        <div id="p1" className='p'>
            <div className='body'>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
            </div>

            <div className='buttonRow'>
                <div className='navButton' onClick={() => {reset()}}>BACK</div>
                <div className='textButton' onClick={() => {}}>LEARN MORE</div>
            </div>
        </div> 

        <div id="p2" className='p'>
            <div className='heading'>Pressure Regulation Lee Jet</div>
            <div className='body'>This single-orifice flow restrictor is suitable for working pressure differentials up to 5000 psi.</div>
            <div className='buttonRow'>
                <div className='navButton' onClick={() => {reset()}}>BACK</div>
                <div className='textButton' onClick={() => {}}>LEARN MORE</div>
            </div>
        </div> 

        <div id="p3" className='p'>
            <div className='heading'>Flow Divider Lee Visco Jet</div>
            <div className='body'>This multi-orifice flow restrictor incorporates slots and spin chambers to form a complex fluid passage.</div>
            <div className='buttonRow'>
                <div className='navButton' onClick={() => {reset()}}>BACK</div>
                <div className='textButton' onClick={() => {}}>LEARN MORE</div>
            </div>
        </div> 

        <div id="p4" className='p'>
            <div className='heading'>Isolation Valve Zero Leak Solenoid Valve</div>
            <div className='body'>This zero-leak solenoid valve incorporates a polyimide ball seat to eliminate leakage.</div>
            <div className='buttonRow'>
                <div className='navButton' onClick={() => {reset()}}>BACK</div>
                <div className='textButton' onClick={() => {}}>LEARN MORE</div>
            </div>
        </div> 

        <div id="p5" className='p'>
            <div className='heading'>Fill Drain Lee Zero Leak Check</div>
            <div className='body'>This threadless, cartridge-style, one-way valve is made with an elastomeric valve seat for improved checked direction leakage performance.</div>    
            <div className='buttonRow'>
                <div className='navButton' onClick={() => {reset()}}>BACK</div>
                <div className='textButton' onClick={() => {}}>LEARN MORE</div>
            </div>
        </div> 

    </>
}





